import { render, staticRenderFns } from "./RegisterPanel.vue?vue&type=template&id=6f21859e&scoped=true&"
import script from "./RegisterPanel.vue?vue&type=script&lang=js&"
export * from "./RegisterPanel.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPanel.vue?vue&type=style&index=0&id=6f21859e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f21859e",
  null
  
)

export default component.exports